import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IWhistleBlowEventLogListItem {
    id: string;
    eventType: number;
    eventTypeStr: string;
    description: string;
    modifyUser: IModifyUser;
}

export class WhistleBlowEventLogListItem implements IWhistleBlowEventLogListItem {
    id: string;
    eventType: number;
    eventTypeStr: string;
    description: string;
    modifyUser: IModifyUser;

    constructor();
    constructor(obj: IWhistleBlowEventLogListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.eventType = obj && obj.eventType || 0;
        this.eventTypeStr = obj && obj.eventTypeStr || "";
        this.description = obj && obj.description || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}